import { motion, AnimatePresence } from "framer-motion";
import { useState } from "react";
import "../style/QuoteInvoiceSection.css";
import QUOTE_IMG from '../assets/stack/quote.jpeg';
import INVOICE_IMG from '../assets/stack/invoice.jpeg';

const QuoteInvoiceSection = () => {
    const [activeTab, setActiveTab] = useState("quote");

    const tabs = [
        { id: "quote", label: "Quote" },
        { id: "invoice", label: "Invoice" }
    ];

    const content = {
        quote: {
            title: "Quoting & Approvals",
            description: "Get quotes approved with a single tap. Send professional quotes by Email or SMS, and let customers approve or decline instantly with automatic status updates.",
            image: QUOTE_IMG
        },
        invoice: {
            title: "Invoicing & Payments",
            description: "Accept card, cash, and bank transfer payments with automatic reminders. Get paid faster and keep cashflow smooth with professional invoices sent via Email or SMS.",
            image: INVOICE_IMG
        }
    };

    const imageVariants = {
        enter: {
            opacity: 0,
            scale: 0.95,
            y: 20
        },
        center: {
            opacity: 1,
            scale: 1,
            y: 0,
            transition: {
                duration: 0.5,
                ease: "easeOut"
            }
        },
        exit: {
            opacity: 0,
            scale: 0.95,
            y: -20,
            transition: {
                duration: 0.3
            }
        }
    };

    return (
        <section className="quote-invoice-section">
            <div className="container">
                <motion.div
                    className="section-content"
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                >
                    {/* Tab Switcher */}
                    <div className="tab-switcher">
                        {tabs.map((tab) => (
                            <button
                                key={tab.id}
                                className={`tab-button ${activeTab === tab.id ? "active" : ""}`}
                                onClick={() => setActiveTab(tab.id)}
                            >
                                {tab.label}
                            </button>
                        ))}
                    </div>
                    {/* Text Content */}
                    <AnimatePresence mode="wait">
                        <motion.div
                            key={activeTab}
                            initial={{ opacity: 0, y: 10 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: -10 }}
                            transition={{ duration: 0.4 }}
                            className="text-content"
                        >
                            <h2 className="section-title">{content[activeTab].title}</h2>
                            <p className="section-description mb-5">{content[activeTab].description}</p>
                        </motion.div>
                    </AnimatePresence>

                    {/* Image Display */}
                    <div className="image-container">
                        <AnimatePresence mode="wait">
                            <motion.div
                                key={activeTab}
                                variants={imageVariants}
                                initial="enter"
                                animate="center"
                                exit="exit"
                                className="image-wrapper"
                            >
                                <img
                                    src={content[activeTab].image}
                                    alt={content[activeTab].title}
                                    className="feature-image"
                                />
                            </motion.div>
                        </AnimatePresence>
                    </div>


                </motion.div>
            </div>
        </section>
    );
};

export default QuoteInvoiceSection;